import { lazy } from 'react';

const RefreshMtv = lazy(() =>
  import('./refresh-mtv/page.js').then((module) => ({ default: module.RefreshMtv })),
);
const DbNotification = lazy(() =>
  import('./notification/page.js').then((module) => ({ default: module.DbNotification })),
);
const CronManager = lazy(() => import('./cron/page.js').then((module) => ({ default: module.CronManager })));
const CacheManager = lazy(() =>
  import('./cache/page.js').then((module) => ({ default: module.CacheManager })),
);

export { CacheManager, CronManager, DbNotification, RefreshMtv };
